(function () {
  // 세트처럼 취급할 상품 ID, 듀오 제품 (.product__title h1의 rel 값)
  const FORCE_SET_IDS = [
    '10316141855010',
    '10089482289442',
    '10316179865890'
  ];

  // 세트 상품이면 제외
  const SET_SELECTOR = '.is-set-item';
  function isSetProduct() {
    // 기존 조건: is-set-item이 존재
    if (document.querySelector(SET_SELECTOR)) return true;

    // 추가 조건: 현재 상품 ID가 지정 목록에 포함
    const el = document.querySelector('.product__title h1');
    const productId = el ? String(el.getAttribute('rel') || '').trim() : '';
    return FORCE_SET_IDS.includes(productId);
  }

  // Shadow DOM, iframe 안쪽까지 탐색
  function deepQuery(selector, root) {
    root = root || document;

    const found = root.querySelector(selector);
    if (found) return found;

    const all = root.querySelectorAll('*');
    for (const node of all) {
      if (node.shadowRoot) {
        const r = deepQuery(selector, node.shadowRoot);
        if (r) return r;
      }
      if (node.tagName === 'IFRAME') {
        try {
          const doc = node.contentDocument;
          if (doc) {
            const r = deepQuery(selector, doc);
            if (r) return r;
          }
        } catch (e) { /* cross-origin iframe */ }
      }
    }
    return null;
  }

  // .org_price 숨김/표시
  function toggleOrgPrice(hide) {
    document.querySelectorAll('.org_price').forEach((el) => {
      el.style.display = hide ? 'none' : '';
    });
  }

  function watchOneTime(widgetRoot) {
    let lastState = null;

    const check = () => {
      // 세트 상품이면 아무 동작 안 함 (이미 숨겨둔 게 있으면 원복)
      if (isSetProduct()) {
        if (lastState !== null) {
          toggleOrgPrice(false);
          lastState = null;
        }
        return;
      }

      const btn = deepQuery('.rc-selection__onetime', widgetRoot);
      if (!btn) return;

      const selected = btn.hasAttribute('rc-selected');
      if (selected === lastState) return; // 상태가 바뀔 때만 실행
      lastState = selected;

      if (selected) {
        toggleOrgPrice(true);   // .org_price 숨김
      } else {
        toggleOrgPrice(false);  // .org_price 다시 표시
      }
    };

    check(); // 최초 상태 확인

    const observeOpts = {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['rc-selected', 'rc-not-selected']
    };

    const observer = new MutationObserver(check);
    observer.observe(widgetRoot, observeOpts);

    // 위젯이 Shadow DOM 안에 있으면 그 shadowRoot도 같이 감시
    const rootNode = widgetRoot.getRootNode();
    if (rootNode instanceof ShadowRoot) {
      observer.observe(rootNode, observeOpts);
    }
  }

  let tries = 0;
  const timer = setInterval(() => {
    tries++;
    const el = deepQuery('.rc-widget__root');

    if (el) {
      clearInterval(timer);
      // console.log('✅ .rc-widget__root 생성됨', el);
      watchOneTime(el);
    } else if (tries >= 100) { // 300ms * 100 = 30초
      clearInterval(timer);
      // console.log('❌ 30초 동안 .rc-widget__root를 찾지 못함');
    }
  }, 300);
})();